module.exports = __webpack_public_path__ + "img/Photo.9504761f.svg";